// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"styles_sectionWrapper__2UiVr","sectionTitle":"styles_sectionTitle__ezjVC","title":"styles_title__HqGcx"};